module.exports = __webpack_public_path__ + "img/bespoke70_04.d1d6dac7.jpg";